<template>
	<v-card max-width="300">
		<!-- <v-subheader v-if="title != null && title != ''">{{title}}
			<v-btn>测试1</v-btn>
		</v-subheader> -->
		<div style="line-height:40px;color:grey;">
			<span v-html="seat"></span>
			<span v-if="title != null && title != ''">{{title}}</span>
			<span class="right"><slot name="header"></slot></span>
		</div>
		<ul style="padding: 0;line-height:48px;">
			<template v-for="(item,i) in items"  >
				<li :key="i" :class="{active : active == item.id}" @click="select(item.id)">
					<slot></slot>
					<span v-html="seat"></span>
					<span>{{item.name}}</span>
					<span class="right"><slot name="li-right-first" :item="item" :index="i"></slot></span>
					<span class="right"><slot name="li-right-second" :item="item" :index="i"></slot></span>
				</li>
			</template>
		</ul>
	</v-card>
</template>
<script>
	export default{
		data(){
			return{
				seat:"&#12288;",
				active:'',

			}
		},
		props:{
			title:{
				type:String,
				default:""
			},
			items:{
				type:Array
			}
		},
		methods:{
			select(id){
				this.active = id;
			},
			//设置当前选中 参数(id)
			setCurrentKey(id){
				this.active = id;
			},
			//获取当前选中id
			getCurrentKey(){
				return this.active;
			}
		},
		watch:{
			active(val){
				this.$emit('return-current',val);
			}
		}
	}
</script>
<style>
	ul{
		list-style: none;
		padding: 0;
		cursor: pointer;

	}
	ul li:hover{
		background-color:#b3d4fc;
	}
	.active {
	   background: cornflowerblue;
	 }
	.right{
		float: right;
	}
</style>